//DEV01
const config = {
     identityPoolId: "us-west-2:7f0b82d0-1266-4b8c-aa3a-c55a4965bf99",
     region: "us-west-2",
     userPoolId: "us-west-2_V21PZyS43",
     userPoolWebClientId: "4s8iu63sgldpbd761anetr762r",
     authenticationFlowType: "USER_PASSWORD_AUTH"
};

//QA01
// const config = {
//     identityPoolId: "us-west-2:7f0b82d0-1266-4b8c-aa3a-c55a4965bf99",
//     region: "us-west-2",
//     userPoolId: "us-west-2_V21PZyS43",
//     userPoolWebClientId: "4s8iu63sgldpbd761anetr762r",
//     authenticationFlowType: "USER_PASSWORD_AUTH"
// };

export default config;